<ng-content />
@if (!shouldHideEmptyErrorPlaceholder || (errorsSubject | async)) {
	<meic-validation-message
		data-testid="error"
		[errors]="errorsSubject | async"
	/>
}
